import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { ManageUserService } from '../manage-user.service';
import { CurrencyPipe, formatDate } from '@angular/common'; 
import * as moment from 'moment';
import { JwtHelperService } from "@auth0/angular-jwt";
const helper = new JwtHelperService();

@Component({
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.scss'],
  providers: [CurrencyPipe]
})
export class AllUsersComponent extends FeaturesBaseComponent implements OnInit {
  rowSelection: string;
  rowData: any[];
  columnDefs: any[];
  searchValue: any;
  showUpdateUser: boolean = false;
  selectedRows: any;
  private gridApi;
  private gridColumnApi;
  showUpdateRetailer: boolean;
  userRole: string = "";
  
  constructor(private router: Router, private manageuserService: ManageUserService, private currencyPipe: CurrencyPipe) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
  }

  ngOnInit(): void {
    super.ngOnInit()
    this.initGrid()
  }
  initGrid() {
    this.manageuserService.getAllUsers().subscribe(
      res => {
        if (res['httpcode'] != 200) {
          return
        }
        this.rowData = res['data'];
      }
    );
    this.rowSelection = 'single',

      this.columnDefs = [
        { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true }, 
        { field: 'userId', headerName: 'userId', width: 120, hide: true,  },
        { field: 'userName', headerName: 'Username', width: 180,},
        { field: 'email', headerName: 'Email', width: 150 },
        { field: 'phoneNumber', headerName: 'Phone Number', width: 210 },
        { field: 'role', headerName: 'Role', width: 200,  },
        { field: 'subRole', headerName: 'Sub Role', width: 200,  },
      { field: 'status', headerName: 'Status', width: 140, cellRenderer: (data) =>{
        return data.value == 'Active' ? '<span class="text-success">Active</span>' : '<span class="text-warning">Inactive</span>'
      } },
      { field: 'isAccountLocked', headerName: 'Login Status', width: 200, onCellClicked:  (params) =>{
        this.handleunlock(params.data.userId, params.data.isAccountLocked,);
      }, cellRenderer: (data) =>{
        return data.value == 'Yes' ? `<span class="rounded-pill bg-danger py-1 px-3 cur-point"><i class="mi mi-lock-open small-icon mr-1"> </i>Unlock </span>` : ``
      } },
        { field: 'creditLineBalance', headerName: 'Credit Line Balance', width: 250, cellRenderer: (data) => {
          if(data.value == 'NA'){
            return data.value
          }else{  
          return this.currencyPipe.transform(data.value)
          }  
        } },
        { field: 'priceList', headerName: ' Commission Plan', width: 190 },
        { field: 'autoReloadStatus', headerName: 'Auto Reload Status', width: 250, cellRenderer: (data) => {
          if(data.value == 'NA'){
            return data.value
          }
          if(data.value == 'false'){  
          return "No"
          }  
          if(data.value == 'true'){  
            return "Yes"
          }
        }  },
      {
        field: 'accountCreatedDate', headerName: 'Account Created Date', width: 250, sort: "desc", cellRenderer: (data) => {
          return moment(data.value).format('MM/DD/YYYY');
            
        }  },
      ]
      // if (this.userRole === 'Sales Rep' || this.userRole === 'Distributor') {
      //   this.columnDefs.splice(10, 0,
      //     { field: 'priceList', headerName: ' Commission Plan', width: 190 },
      //   )
      // }
  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'Users.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'accountCreatedDate') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter 
      }
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }
  handleunlock(userId,isAccountLocked){
    if(isAccountLocked == 'Yes'){
    this.manageuserService.userUnlock(userId).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        this.toastrService.success('User unlocked successfully!', 'Success', {
          timeOut: 3000,
        })
        this.reloadComponent();  
      }
    })
    }
  }
  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
    }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
  }
  onSelectionChanged(e) {
    
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length > 0 && this.selectedRows[0].role != 'Retailer') {
      this.showUpdateUser = true
      return
    }
    this.showUpdateUser = false;
  }

  updateUser() {
    let userId = this.selectedRows[0].userId;
      this.router.navigate([`/features/manage-users/edit-user/${userId}`])
  }
  ngOnDestroy() {
    super.ngOnDestroy()

  }

}
 